// jQuery nur für Bibliotheken (slick-carousel) importieren
import $ from 'jquery';
window.$ = window.jQuery = $;

import styleSelect from 'styleselect';
import "slick-carousel";
// import magnificPopup from 'magnific-popup';

document.querySelectorAll('.header_button').forEach(function(button) {
    button.addEventListener('click', function() {
        document.body.classList.toggle("header--shownav");
    });
});

document.querySelectorAll('.nav_close, .nav_overlay').forEach(function(element) {
    element.addEventListener('click', function() {
        document.body.classList.toggle("header--shownav");
    });
});

document.querySelectorAll('.nav_select').forEach(function(select) {
    select.addEventListener('change', function() {
        const url = this.value;
        if(url) {
            location.href = url;
        }
    });
});

document.querySelectorAll("select").forEach(function(select) {
    styleSelect("#" + select.id);
});

document.querySelectorAll(".menu--seminars > a").forEach(function(link) {
    link.addEventListener("click", function(e) {
        e.preventDefault();
        this.parentElement.classList.toggle("menu--viewsubmenu");
    });
});

document.querySelectorAll(".subnav-select").forEach(function(select) {
    select.addEventListener("change", function(e) {
        e.preventDefault();
        window.location.href = this.value;
    });
});


document.querySelectorAll("iframe.results").forEach(function(iframe) {
    function setup() {
        let doc;
        try {
            doc = iframe.contentWindow.document;
        } catch (e) {
            return; // Cross-origin content, can't resize or inspect it
        }

        function resizeIframe() {
            iframe.style.height = doc.documentElement.scrollHeight + "px";
        }
        resizeIframe();
        new ResizeObserver(resizeIframe).observe(doc.documentElement);
    }
    iframe.addEventListener("load", setup);
    if (iframe.contentWindow && iframe.contentWindow.document.readyState === "complete") {
        setup();
    }
});

const turnierhelferElement = document.getElementById("Form_Form_Turnierhelfer");
if (turnierhelferElement) {
    function showHideHelfer() {
        const show = turnierhelferElement.checked;
        const elements = [
            document.getElementById("Form_Form_Turnierhelfer_Headline"),
            document.getElementById("Form_Form_Abfahrt_Holder"),
            document.getElementById("Turnierhelfer_Description"),
            ...document.querySelectorAll(".helfer")
        ];
        
        elements.forEach(function(el) {
            if (el) {
                el.style.display = show ? "" : "none";
            }
        });
    }

    turnierhelferElement.addEventListener("change", function() {
        showHideHelfer();
    });

    showHideHelfer();
}

const allDaysElement = document.getElementById("Form_Form_AllDays");
if (allDaysElement) {
    function showHideDays() {
        const checkedInput = allDaysElement.querySelector("input:checked");
        const show = checkedInput && checkedInput.value === "2";
        const daysHolder = document.getElementById("Form_Form_Days_Holder");
        const welcomeElement = document.getElementById("Form_Form_Welcome");
        
        if (daysHolder) {
            daysHolder.style.display = show ? "" : "none";
        }
        if (welcomeElement && welcomeElement.parentElement) {
            welcomeElement.parentElement.style.display = show ? "" : "none";
        }
    }

    allDaysElement.querySelectorAll("input").forEach(function(input) {
        input.addEventListener("change", function() {
            showHideDays();
        });
    });

    showHideDays();

    function updatePrice() {
        let price = 0;
        const checkedInput = allDaysElement.querySelector("input:checked");
        const full = checkedInput && checkedInput.value === "1";
        
        if (full) {
            price = 750;
        } else {
            const daysElement = document.getElementById("Form_Form_Days");
            const days = daysElement ? daysElement.querySelectorAll("input:checked").length : 0;
            const priceMap = {
                "0": 0,
                "1": 150,
                "2": 290,
                "3": 420,
                "4": 540,
                "5": 650,
                "6": 720,
            }
            price = priceMap[String(days)];

            const welcomeCheckbox = document.getElementById("Form_Form_Welcome");
            if(welcomeCheckbox && welcomeCheckbox.checked) {
                price += 45;
            }
        }
        const formattedPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);
        const priceElement = document.getElementById("price");
        if (priceElement) {
            priceElement.textContent = formattedPrice;
        }
    }

    allDaysElement.querySelectorAll("input").forEach(function(input) {
        input.addEventListener("change", updatePrice);
    });
    
    const daysElement = document.getElementById("Form_Form_Days");
    if (daysElement) {
        daysElement.querySelectorAll("input").forEach(function(input) {
            input.addEventListener("change", updatePrice);
        });
    }
    
    const welcomeCheckbox = document.getElementById("Form_Form_Welcome");
    if (welcomeCheckbox) {
        welcomeCheckbox.addEventListener("change", updatePrice);
    }

    updatePrice();
}

$(".section--gallery .gallery_items").slick({
    dots: true,
    fade: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    // variableWidth: true
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});
